var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("您当前无权限访问该页面")])
}
var staticRenderFns = []

export { render, staticRenderFns }